import React from 'react'
import styles from './styles.module.scss'
import BrandBar from '../../ui/BrandBar'

interface HeroHeadingProps {
    // Defaults to the landing page's "Claim compensation for military hearing loss"
    title?: React.ReactNode
    subtitle?: string
    subtitleMobile?: string
    // Small line under the title, e.g. how long the form takes
    tagline?: React.ReactNode
    // Eases the title block down to a smaller size, e.g. once the claim form starts
    compact?: boolean
    // False where the page already has its own logo bar above (e.g. signing)
    brandBar?: boolean
    // Subtitle, title and tagline fade in quickly as the page loads (CSS only)
    fadeIn?: boolean
}

const DEFAULT_TITLE = (
    <>
        Claim compensation for
        <br />
        <span className={styles.noWrap}>military hearing loss</span>
    </>
)

const HeroHeading: React.FC<HeroHeadingProps> = ({
    title = DEFAULT_TITLE,
    subtitle,
    subtitleMobile,
    tagline,
    compact = false,
    brandBar = true,
    fadeIn = false,
}) => {
    return (
        <div
            className={`${styles.heroHeading} ${compact ? styles.compact : ''} ${brandBar ? '' : styles.noBrandBar}`}
        >
            {brandBar && <BrandBar className={styles.topBar} />}
            <div className={styles.content}>
                <div className={`${styles.textBlock} ${fadeIn ? styles.fadeIn : ''}`}>
                    {subtitle && (
                        <>
                            <p className={`${styles.subtitle} ${styles.subtitleDesktop}`}>{subtitle}</p>
                            <p className={`${styles.subtitle} ${styles.subtitleMobile}`}>
                                {subtitleMobile || subtitle}
                            </p>
                        </>
                    )}
                    <h1 className={styles.title}>
                        <span className={styles.primaryText}>{title}</span>
                    </h1>
                    {tagline && <p className={styles.tagline}>{tagline}</p>}
                </div>
            </div>
        </div>
    )
}

export default HeroHeading
